<template>
  <div>
    <h2>每日推薦</h2>
    <!--
    <el-link type="primary" :href="lineLink3" target="_blank" style="font-size: 18px"
      >徵求美容師(請點我)</el-link
    >
    <br />
    -->
    <label style="color: red">點圖可放大，表格可往右滑</label>
  </div>

  <div class="container" id="con1">
    <ul class="nav nav-tabs" id="nav">
      <li v-for="tab in tabs" v-bind:key="tab" class="nav-item">
        <a
          href="#"
          class="nav-link"
          :class="{ active: tab.isActive }"
          @click="setActive(tab)"
          >{{ tab.name }}</a
        >
      </li>
      <li class="nav-item dropdown">
        <a
          class="nav-link dropdown-toggle"
          data-bs-toggle="dropdown"
          href="#"
          role="button"
          aria-expanded="false"
          id="DropdownMenu"
          >更多</a
        >
        <ul class="dropdown-menu"></ul>
      </li>
    </ul>

    <div class="tab-content" id="tab1">
      <DailyPush :week="week"></DailyPush>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import DailyPush from "@/components/DailyPush.vue";

export default {
  data() {
    return {
      tabs: [
        {
          name: "星期一",
          value: "1",
          isActive: false,
        },
        {
          name: "星期二",
          value: "2",
          isActive: false,
        },
        {
          name: "星期三",
          value: "3",
          isActive: false,
        },
        {
          name: "星期四",
          value: "4",
          isActive: false,
        },
        {
          name: "星期五",
          value: "5",
          isActive: false,
        },
        {
          name: "星期六",
          value: "6",
          isActive: false,
        },
        {
          name: "星期天",
          value: "7",
          isActive: false,
        },
      ],
      activeTab: {},
      conWidth: "",
      week: "",
      lineLink3: "",
    };
  },
  components: {
    DailyPush,
  },
  methods: {
    selectLink() {
      axios
        .post("/php/spa_config.php", {
          action: "selectLink",
        })
        .then((res) => {
          var findLine3 = res.data.find((e) => e.code === "lineLink3");
          if (findLine3) {
            this.lineLink3 = findLine3.text;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    setActive: function (tab) {
      tab.isActive = true;
      this.activeTab = tab;
      this.week = tab.value;

      var name = this.activeTab.name;
      this.tabs.forEach(function (tab) {
        if (tab.name !== name) {
          tab.isActive = false;
        }
      });
    },
    setDropdown: function (menu, maxHeight) {
      var nav = $(menu);
      var navHeight = nav.innerHeight();
      if (navHeight >= maxHeight) {
        $(menu + " .dropdown").removeClass("d-none");
        $(".navbar-nav").removeClass("w-auto").addClass("w-100");

        while (navHeight > maxHeight) {
          //  add child to dropdown
          var children = nav.children(menu + " li:not(:last-child)");
          var count = children.length;
          $(children[count - 1]).prependTo(menu + " .dropdown-menu");
          navHeight = nav.innerHeight();
        }
        $(".navbar-nav").addClass("w-auto").removeClass("w-100");
      } else {
        var collapsed = $(menu + " .dropdown-menu").children(menu + " li");

        if (collapsed.length === 0) {
          $(menu + " .dropdown").addClass("d-none");
        }

        while (
          navHeight < maxHeight &&
          nav.children(menu + " li").length > 0 &&
          collapsed.length > 0
        ) {
          //  remove child from dropdown
          collapsed = $(menu + " .dropdown-menu").children("li");
          $(collapsed[0]).insertBefore(nav.children(menu + " li:last-child"));
          navHeight = nav.innerHeight();
        }

        if (navHeight > maxHeight) {
          this.setDropdown(menu, maxHeight);
        }
      }
    },
    resizeHandler: function () {
      this.setDropdown("#nav", 50);
    },
  },
  created: function () {
    window.addEventListener("resize", this.resizeHandler);
  },
  unmounted() {
    window.removeEventListener("resize", this.resizeHandler);
  },
  mounted() {
    this.selectLink();
    this.conWidth = $("#con1").width();
    this.setDropdown("#nav", 50);

    var now = new Date();

    if ("0" == now.getDay()) {
      var findTab = this.tabs.find((e) => e.value === "7");
      findTab.isActive = true;
      this.week = findTab.value;
    } else {
      var findTab1 = this.tabs.find((e) => e.value == now.getDay());
      findTab1.isActive = true;
      this.week = findTab1.value;
    }
  },
};
</script>

<style>
.nav-tabsa {
  overflow-x: auto;
  overflow-y: hidden;
  flex-wrap: nowrap;
}
</style>
